import posthog from 'posthog-js'

const POSTHOG_KEY = 'phc_kfe1SBtQ3vX69pJl54lyJwosnEM33cgeu8VkFzdrdTY'
const POSTHOG_HOST = 'https://us.i.posthog.com'

let initialized = false

export function initPostHog() {
  if (initialized) return
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    person_profiles: 'identified_only',
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: true,
  })
  initialized = true
}

// ── Event helpers ──

export function trackEvent(event: string, properties?: Record<string, unknown>) {
  posthog.capture(event, properties)
}

export function trackOnboardingStep(step: string) {
  trackEvent('onboarding_step', { step })
}

export function trackChatMessage() {
  trackEvent('chat_message_sent')
}

export function trackLabelPrint() {
  trackEvent('label_print')
}

export function trackFeedbackSubmitted() {
  trackEvent('feedback_submitted')
}
